import User from "byzantine/src/User";
import AccountNumberField from "../Fields/AccountNumberField";
import AccountTypeDropdown from "../Fields/AccountTypeDropdown";
import DobField from "../Fields/DobField";
import EinField from "../Fields/EinField";
import EmailField from "../Fields/EmailField";
import InternationalTaxIdField from "../Fields/InternationalTaxIdField";
import NameField from "../Fields/NameField";
import PassportCountryField from "../Fields/PassportCountryField";
import PassportNumberField from "../Fields/PassportNumberField";
import TaxIdField from "../Fields/TaxIdField";
import COUNTRY_CODES_WHICH_DO_NOT_ISSUE_FTIN from "../constants";

type UseVisibleFieldsProps = {
  formData: Record<string, any>;
  coreHasEmails: boolean;
  institution: API.Institution;
};

const useVisibleFields = ({
  formData,
  coreHasEmails,
  institution
}: UseVisibleFieldsProps) => {
  const selectedCountryCode = formData?.passport_country || "";
  const userCategory = formData?.user_category ?? User.PERSONAL;

  return [
    <AccountTypeDropdown key="user_category" />,
    institution.prompt_account_number && (
      <AccountNumberField key="account_number" revalidateErrorsOnBlur />
    ),
    <NameField key="first_name" field="first_name" revalidateErrorsOnBlur />,
    <NameField key="last_name" field="last_name" revalidateErrorsOnBlur />,
    <PassportCountryField key="passport_country" />,
    <PassportNumberField key="passport_number" revalidateErrorsOnBlur />,
    <DobField key="dob" revalidateErrorsOnBlur />,
    <TaxIdField key="tin" required={false} revalidateErrorsOnBlur />,
    !coreHasEmails && <EmailField key="email" revalidateErrorsOnBlur />,
    !COUNTRY_CODES_WHICH_DO_NOT_ISSUE_FTIN.includes(selectedCountryCode) && (
      <InternationalTaxIdField
        key="international_tax_id"
        revalidateErrorsOnBlur
      />
    ),
    userCategory === User.BUSINESS && (
      <EinField key="ein" revalidateErrorsOnBlur />
    )
  ].filter(Boolean);
};

export default useVisibleFields;
